import '../../resources/css/layout/LoginLayout.scss';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  doLogout,
  LOGIN_SUCCESS,
  RE_LOGIN_SUCCESS,
  VERIFY_EMAIL,
  VERIFY_EMAIL_LOADING,
  VERIFY_EMAIL_SEND_CODE_FAIL, VERIFY_EMAIL_SEND_CODE_SUCCESS
} from '../../actions/login/index';
import LoginForm from '../../components/login/LoginForm';
import {openModal} from '../../actions/index';
import { doActivePage } from '../../actions/menu/index';
import ModalConfirm from '../../components/common/ModalConfirm';
import ModalTip from '../../components/common/ModalTip';
import ModalAlert from '../../components/common/ModalAlert';
import ModalLoading from '../../components/common/ModalLoading';
import Loading from '../../components/common/Loading';
import { doGetAccountOperationStatusList } from '../../actions/settings/index';
import { doSelectSite } from '../../actions/site';
import webSocketService from "../../services/WebSocketService";


class LoginLayout extends Component {

  constructor(props) {
    super(props);
    const { activePage, doActivePage } = this.props;
    if (activePage !== 'Login') {
      doActivePage('Login');
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const { menuActivePage, history, status, doGetAccountOperationStatusList, accountRole, authToken, doSelectSite, accountInfo } = this.props;

    if (prevProps.menuActivePage !== menuActivePage) {
      if (menuActivePage && history) {
        history.push(window.CONFIG.WEB_ROOT + '/' + menuActivePage);
      }
    }

    if (status === LOGIN_SUCCESS || status === RE_LOGIN_SUCCESS) {
      doGetAccountOperationStatusList(authToken);  
      doSelectSite(accountInfo.siteId)
      if (accountRole?.flagSuperAdmin){
        history.push(window.CONFIG.WEB_ROOT + '/site')
      } else {
        history.push(window.CONFIG.WEB_ROOT + '/rf_map/project')
      }
    }
  }

  componentDidMount() {
    webSocketService.unsubscribe(`${window.CONFIG.SWS_SERVER_WS.subscribePrefix}/logout`);
  }

  applyAccount = (e) => {
    const { doActivePage } = this.props;
    doActivePage('Signup');
    // this.setState({displayPage: 'create'});
  }

  render() {
    const { doGetAccountOperationStatusList,status, loading , authToken } = this.props;

    if (status === LOGIN_SUCCESS || status === RE_LOGIN_SUCCESS) {  
      doGetAccountOperationStatusList(authToken);  
      return (
        <Redirect to={{
          pathname: window.CONFIG.WEB_ROOT + window.CONFIG.DEFAULT_MAIN_PAGE
        }}/>
      );
    }

    const isVerifyingEmail = [VERIFY_EMAIL, VERIFY_EMAIL_LOADING, VERIFY_EMAIL_SEND_CODE_FAIL, VERIFY_EMAIL_SEND_CODE_SUCCESS].includes(status)

    return (
      <div className='area-login-page'>
        <div className='area-logo'>
          <span className='icon-logo-prism-dark-large'/>
        </div>
        <div className='area-login-block'>          
          <div className='area-login-logo-word'>
            <span className='logo-word'>{ isVerifyingEmail ? 'VERIFY YOUR EMAIL ADDRESS' : 'Sign In' }</span>
          </div>
          <LoginForm></LoginForm>
          <Loading loading={loading} center={true}></Loading>
        </div>
        {/* <div className='main-footer'>
          <MainFooter/>
        </div>*/}
        {/*<ModalForgotPwd></ModalForgotPwd>*/}
        <ModalConfirm></ModalConfirm>
			  <ModalTip></ModalTip>
        <ModalAlert></ModalAlert>
        <ModalLoading></ModalLoading>
      </div>      
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // const errMsg = ownProps.location.state ? ownProps.location.state.errMsg : null;

  return {
    // errMsg: errMsg || state.loginReducers.errMsg,
    menuActivePage: state.menuReducers.activePage,
    status: state.loginReducers.status,
    loading: state.loginReducers.loading,
    authToken: state.loginReducers.authToken,
    accountRole: state.loginReducers.accountRole,
    accountInfo: state.loginReducers.accountInfo,
    roleTableAuth: state.loginReducers.roleTableAuth
  }
}

export default connect(
  mapStateToProps,
  { openModal, doActivePage, doGetAccountOperationStatusList, doSelectSite, doLogout }
)(LoginLayout)